import { Toast, Tooltip, Popover } from './_bootstrap';

(function () {

  const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
  const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new Popover(popoverTriggerEl))

  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))
})();
function setPageContentHeight() {
  const header = document.querySelector('.header');
  const footer = document.querySelector('.page__footer');
  const content = document.querySelector('.page__content');

  if (!header || !footer || !content) return;

  const headerHeight = header.offsetHeight;
  const footerHeight = footer.offsetHeight;
  const viewportHeight = window.innerHeight;

  // A tartalom legalább akkora legyen, hogy a footer az aljára kerüljön
  const baseHeight = viewportHeight - headerHeight - footerHeight + 100;
  const minContentHeight = Math.max(baseHeight, 250);

  content.style.minHeight = minContentHeight + 'px';
}

// Futtatás oldal betöltéskor és átméretezéskor
window.addEventListener('load', setPageContentHeight);
window.addEventListener('resize', setPageContentHeight);
function scrollToHashTarget() {
  const hash = window.location.hash.replace('#', '').trim();
  if (!hash) return;

  // 1) Először próbáljuk id-ként
  let target = document.getElementById(hash);

  // 2) Ha nincs id, keressük class alapján
  if (!target) {
    target = document.querySelector('.' + hash);
  }

  // 3) Ha megtaláltuk → scroll
  if (target) {
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  // oldal betöltésekor
  scrollToHashTarget();

  // ha később módosul a hash (pl. kattintasz egy #linkre)
  window.addEventListener('hashchange', scrollToHashTarget);
});


